import { connect } from 'react-redux';

import { IApplicationState, TThunkAction } from '../../types/redux';
import { getMeta, persistFilters } from '../../actions/filters';
import { FiltersSearchButtons } from '../../components/FiltersSearchButtons';
import { formatOfferCount } from './utils/formatOfferCount';
import { selectPageKind } from '../../selectors/pageKind';
import { selectDisableRegionExpansion } from '../../selectors/regionExpansion';
import { EPageKind } from '../../types/page';
import { EMetaStatus, IGeocodeState } from '../../types/filters';
import { doChecksBeforeSearch } from '../../actions/filters/checksBeforeSearch/doChecksBeforeSearch';
import { selectNeedSkipDatesCookie } from '../../selectors/filters/datesModal/selectNeedSkipDatesCookie';

interface IFiltersSearchButtonsContainerStateProps {
  pageKind: EPageKind;
  metaStatus: EMetaStatus;
  url: string;
  mapUrl: string;
  geocode: IGeocodeState;
  offerCount: string;
  disableRegionExpansion: boolean;
  needSkipDatesCookie: boolean;
}

interface IFiltersSearchButtonsContainerDispatchProps {
  getMeta(): void;
  persistFilters(): void;
  doChecksBeforeSearch(): TThunkAction<boolean>;
}

interface IOwnProps {
  isDatesModalAutoOpenRSEnabled: boolean;
}

export function mapStateToProps(
  state: IApplicationState,
  ownProps: IOwnProps,
): IFiltersSearchButtonsContainerStateProps {
  const {
    filters: { meta },
  } = state;
  const { isDatesModalAutoOpenRSEnabled } = ownProps;

  const pageKind = selectPageKind(state);
  const disableRegionExpansion = selectDisableRegionExpansion(state);

  const offerCount = formatOfferCount({ offerCount: meta.count });

  // Временное решение переходного периода, пока даты не обязательны
  const needSkipDatesCookie = isDatesModalAutoOpenRSEnabled && selectNeedSkipDatesCookie(state);

  return {
    pageKind,
    metaStatus: meta.status,
    url: meta.url,
    mapUrl: meta.mapUrl,
    geocode: state.filters.geocode,
    offerCount,
    disableRegionExpansion,
    needSkipDatesCookie,
  };
}

export const mapDispatchToProps: IFiltersSearchButtonsContainerDispatchProps = {
  getMeta,
  persistFilters,
  doChecksBeforeSearch,
};

export const FiltersSearchButtonsContainer = connect(mapStateToProps, mapDispatchToProps)(FiltersSearchButtons);
